import React from "react";
import ReactPaginate from "react-paginate";
import Loading from "../../../components/loading";

export default function ListLocation({
    loading,
    filteredLocations,
    selected,
    handleSelect,
    handleToggleStatus,
    getStatusClass,
    pageCount,
    handlePageClick,
}) {
    return (
        <div className="table-responsive">
            <table className="table table-striped table-bordered mb-0">
                <thead className="table-light">
                    <tr>
                        <th>Select</th>
                        <th>Location Name</th>
                        <th>Location Code</th>
                        <th>From KMS/CH</th>
                        <th>To KMS/CH</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="6" className="text-center py-4">
                                <Loading />
                            </td>
                        </tr>
                    ) : filteredLocations.length > 0 ? (
                        filteredLocations.map((l) => (
                            <tr key={l.id}>
                                <td>
                                    <input
                                        type="radio"
                                        name="locationSelect"
                                        disabled={l.status === "Inactive"}
                                        checked={selected === l.id}
                                        onChange={() => handleSelect(l.id)}
                                    />
                                </td>
                                <td>{l.locationName}</td>
                                <td>{l.locationCode}</td>
                                <td>{l.fromKMS}</td>
                                <td>{l.toKMS}</td>
                                <td>
                                    <span
                                        className={`badge ${getStatusClass(l.status)}`}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleToggleStatus(l.id, l.status)}
                                    >
                                        {l.status}
                                    </span>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="6" className="text-center text-muted">
                                No locations found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <ReactPaginate
                breakLabel="..."
                nextLabel="Next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="< Previous"
                containerClassName="pagination-container"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
            />
        </div>
    );
}
